import { KEYCLOAK_ROLES } from '../../shared/constants/auth.constants';
import { SystemListView } from '../../shared/utils/list-views';
import { NAVIGATION_CONFIG, NavItem } from '../configs/navigation.config';
import { ADVERTISEMENTS_SYSTEM_VIEWS } from '../../features/advertisements/pages/advertisements-list/advertisements-list.views';
import { CATEGORIES_SYSTEM_VIEWS } from '../../features/categories/pages/categories-list/categories-list.views';
import { FINANCIAL_RECONCILIATION_SYSTEM_VIEWS } from '../../features/financial-reconciliation/pages/financial-reconciliation-list/financial-reconciliation-list.views';
import { INVOICES_SYSTEM_VIEWS } from '../../features/invoices/pages/invoices-list/invoices-list.views';
import { ORDERS_SYSTEM_VIEWS } from '../../features/orders/pages/orders-list/orders-list.views';
import { PROCESSING_LOGS_SYSTEM_VIEWS } from '../../features/processing-logs/pages/processing-logs-list/processing-logs-list.views';
import { PRODUCTS_SYSTEM_VIEWS } from '../../features/products/pages/products-list/products-list.views';
import { CONFERENCE_SYSTEM_VIEWS } from '../../features/sale-conferences/pages/conference-list/conference-list.views';
import { VARIATIONS_SYSTEM_VIEWS } from '../../features/variations/pages/variations-list/variations-list.views';

/** Tela com visões salvas: a mesma chave do ListViewsState dela e a rota que a abre. */
export interface ViewScreen {
  screenKey: string;
  url: string;
  title: string;
  roles: string[];
  systemViews: SystemListView[];
}

// Toda tela que monta um ListViewsState entra aqui, com a MESMA screenKey (é a chave das visões no
// servidor). Título e permissão vêm do menu (NAVIGATION_CONFIG); só quem não está no menu declara.
const SCREENS: (Omit<ViewScreen, 'title' | 'roles'> & Partial<Pick<ViewScreen, 'title' | 'roles'>>)[] = [
  { screenKey: 'pedidos', url: '/pedidos', systemViews: ORDERS_SYSTEM_VIEWS },
  { screenKey: 'notas-fiscais', url: '/notas-fiscais', systemViews: INVOICES_SYSTEM_VIEWS },
  { screenKey: 'conferencia', url: '/conferencia', systemViews: CONFERENCE_SYSTEM_VIEWS },
  {
    screenKey: 'conferencia-ranking',
    url: '/conferencia/ranking',
    title: 'Ranking da conferência',
    roles: [KEYCLOAK_ROLES.SALE_CONFERENCE_RANKING],
    systemViews: [],
  },
  { screenKey: 'conciliacao-financeira', url: '/conciliacao-financeira', systemViews: FINANCIAL_RECONCILIATION_SYSTEM_VIEWS },
  { screenKey: 'produtos', url: '/produtos', systemViews: PRODUCTS_SYSTEM_VIEWS },
  { screenKey: 'anuncios', url: '/anuncios', systemViews: ADVERTISEMENTS_SYSTEM_VIEWS },
  { screenKey: 'categorias', url: '/categorias', systemViews: CATEGORIES_SYSTEM_VIEWS },
  { screenKey: 'variacoes', url: '/variacoes', systemViews: VARIATIONS_SYSTEM_VIEWS },
  { screenKey: 'logs-processamento', url: '/logs-processamento', systemViews: PROCESSING_LOGS_SYSTEM_VIEWS },
  { screenKey: 'empresas', url: '/empresas', systemViews: [] },
  { screenKey: 'grupos-empresas', url: '/grupos-empresas', systemViews: [] },
  { screenKey: 'acessos', url: '/acessos', systemViews: [] },
  { screenKey: 'identidade-visual', url: '/identidade-visual', systemViews: [] },
];

function navItemByUrl(url: string): NavItem | undefined {
  return NAVIGATION_CONFIG.flatMap((s) => s.items)
    .flatMap((item) => [item, ...(item.children ?? [])])
    .find((item) => item.url === url);
}

export const VIEW_SCREENS: ViewScreen[] = SCREENS.map((screen) => {
  const nav = navItemByUrl(screen.url);
  return {
    ...screen,
    title: screen.title ?? nav?.title ?? screen.screenKey,
    roles: screen.roles ?? nav?.roles ?? [],
  };
});
